module.exports = __webpack_public_path__ + "static/img/icon_apply.e42d65b0.png";